import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './assets/css/index.css'
import './assets/css/font.css'
import './assets/css/advanced.css'

import VueFilesPreview from 'vue-files-preview'
import 'vue-files-preview/lib/style.css'
import App from './App.vue'
import router from './router'

const app = createApp(App)
app.config.devtools = false
app.use(createPinia())

app.use(VueFilesPreview)
app.use(router)
app.mount('#app')
